import React from "react";
import "./Loader.css";

export const Loading = () => {
  return (
    <div className="loader">
      <div className="loader_element"></div>
      <div className="loader_element"></div>
      <div className="loader_element"></div>
    </div>
  );
};
